<article class="seo-page">
    <header class="seo-page__hero">
        <div class="container seo-page__hero-shell">
            <nav aria-label="breadcrumb" class="seo-page__breadcrumbs">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item" [class.active]="last"
                        *ngFor="let breadcrumb of breadcrumbTrail; let last = last; let breadcrumbIndex = index"
                        data-aos="fade-down"
                        [attr.data-aos-delay]="getAosDelay(breadcrumbIndex, 70, 210)">
                        <a *ngIf="!last" [routerLink]="breadcrumb.path">{{ breadcrumb.name }}</a>
                        <span *ngIf="last" aria-current="page">{{ breadcrumb.name }}</span>
                    </li>
                </ol>
            </nav>

            <div class="seo-page__hero-grid">
                <div class="seo-page__hero-copy" data-aos="fade-up">
                    <div class="seo-page__eyebrow">{{ page.hero.eyebrow }}</div>
                    <h1 data-aos="fade-right" data-aos-delay="70">{{ template?.data.page?.h1 }}</h1>
                    <p class="seo-page__lead">{{ page.hero.lead }}</p>

                    <div class="seo-page__hero-points" data-aos="fade-up" data-aos-delay="70">
                        <div class="seo-page__hero-points-kicker">Коротко о главном</div>
                        <div class="seo-page__hero-points-flow">
                            <span class="seo-page__hero-point" *ngFor="let chip of page.hero.chips">
                                <span class="seo-page__hero-point-icon" aria-hidden="true"></span>
                                <span class="seo-page__hero-point-text">{{ chip }}</span>
                            </span>
                        </div>
                    </div>

                    <ul class="seo-page__bullet-list">
                        <li *ngFor="let bullet of page.hero.bullets; let bulletIndex = index"
                            data-aos="fade-up" [attr.data-aos-delay]="getAosDelay(bulletIndex, 90, 270)">{{ bullet }}
                        </li>
                    </ul>

                    <div class="seo-page__actions">
                        <a *ngIf="page.hero.primaryAction && linkIsExternal(page.hero.primaryAction)"
                           class="seo-page__button seo-page__button--primary"
                           [href]="externalActionUrl(page.hero.primaryAction, 'hero_primary')"
                           (click)="trackExternalAction(page.hero.primaryAction, 'hero_primary')"
                           [attr.rel]="page.hero.primaryAction.rel || 'noopener'"
                           target="_blank">
                            {{ page.hero.primaryAction.label }}
                        </a>
                        <a *ngIf="page.hero.primaryAction && !linkIsExternal(page.hero.primaryAction)"
                           class="seo-page__button seo-page__button--primary"
                           [routerLink]="internalActionPath(page.hero.primaryAction)"
                           [fragment]="internalActionFragment(page.hero.primaryAction)">
                            {{ page.hero.primaryAction.label }}
                        </a>

                        <a *ngIf="page.hero.secondaryAction && linkIsExternal(page.hero.secondaryAction)"
                           class="seo-page__button seo-page__button--ghost"
                           [href]="externalActionUrl(page.hero.secondaryAction, 'hero_secondary')"
                           (click)="trackExternalAction(page.hero.secondaryAction, 'hero_secondary')"
                           [attr.rel]="page.hero.secondaryAction.rel || 'noopener'"
                           target="_blank">
                            {{ page.hero.secondaryAction.label }}
                        </a>
                        <a *ngIf="page.hero.secondaryAction && !linkIsExternal(page.hero.secondaryAction)"
                           class="seo-page__button seo-page__button--ghost"
                           [routerLink]="internalActionPath(page.hero.secondaryAction)"
                           [fragment]="internalActionFragment(page.hero.secondaryAction)">
                            {{ page.hero.secondaryAction.label }}
                        </a>
                    </div>
                </div>

                <figure class="seo-page__showcase" *ngIf="page.hero.image" data-aos="zoom-out" data-aos-delay="120">
                    <img [src]="page.hero.image.src" [alt]="page.hero.image.alt" loading="eager" fetchpriority="high"
                         decoding="async">
                    <figcaption *ngIf="page.hero.image.caption">{{ page.hero.image.caption }}</figcaption>
                </figure>
            </div>

            <button class="seo-page__scroll-cue" type="button" (click)="scrollToNextScreen()"
                    title="Прокрутить к содержимому страницы"
                    aria-label="Прокрутить к содержимому страницы" data-aos="fade-up" data-aos-delay="180">
                <span class="seo-page__scroll-cue-icon" aria-hidden="true"></span>
            </button>
        </div>
    </header>

    <div class="container" id="page-content">
        <app-public-trip-calculator
            *ngIf="page.key === 'tripCalculator'"
            class="seo-page__calculator-anchor"
            id="trip-calculator"
            data-aos="fade-up"
            data-aos-delay="80"
        ></app-public-trip-calculator>

        <app-route-planner
            *ngIf="page.key === 'routeDistance'"
            class="seo-page__calculator-anchor"
            id="distance-calculator"
            context="distance"
            data-aos="fade-up"
            data-aos-delay="80"
        ></app-route-planner>

        <app-public-fuel-calculator
            *ngIf="page.key === 'fuel'"
            class="seo-page__calculator-anchor"
            id="fuel-calculator"
            data-aos="fade-up"
            data-aos-delay="80"
        ></app-public-fuel-calculator>

        <app-public-trip-calculator
            *ngIf="page.key === 'fuel'"
            class="seo-page__calculator-anchor"
            context="fuel"
            data-aos="fade-up"
            data-aos-delay="100"
        ></app-public-trip-calculator>

        <section class="seo-page__intro" id="page-intro">
            <div data-aos="fade-up">
                <div class="seo-page__eyebrow seo-page__eyebrow--dark">В центре внимания</div>
                <h2>{{ page.intro.title }}</h2>
                <p>{{ page.intro.text }}</p>
            </div>
            <aside class="seo-page__toc" *ngIf="page.sections.length" data-aos="fade-left" data-aos-delay="90">
                <h2>Что есть на странице</h2>
                <ul>
                    <li *ngFor="let section of page.sections">
                        <a [href]="page.path + '#' + section.id">{{ section.title }}</a>
                    </li>
                </ul>
            </aside>
        </section>

        <div class="seo-page__calculator-anchor"
             id="trip-calculator"
             *ngIf="page.key === 'home'"
             data-aos="fade-up"
             data-aos-delay="80">
            <app-public-trip-calculator
                [compact]="page.key === 'home'"
                context="landing"
            ></app-public-trip-calculator>
        </div>

        <section class="seo-page__section" *ngFor="let section of page.sections; let sectionIndex = index"
                 [attr.id]="section.id" data-aos="fade-up" [attr.data-aos-delay]="getAosDelay(sectionIndex, 70, 210)">
            <div class="seo-page__section-head">
                <div class="seo-page__eyebrow seo-page__eyebrow--dark" *ngIf="section.eyebrow">{{ section.eyebrow }}
                </div>
                <h2>{{ section.title }}</h2>
                <p *ngIf="section.lead">{{ section.lead }}</p>
            </div>

            <div class="seo-page__grid" *ngIf="section.image; else textOnlySection">
                <div>
                    <p *ngFor="let paragraph of section.paragraphs">{{ paragraph }}</p>

                    <ul class="seo-page__plain-list" *ngIf="section.bullets?.length">
                        <li *ngFor="let bullet of section.bullets">{{ bullet }}</li>
                    </ul>

                    <ol class="seo-page__plain-list seo-page__plain-list--ordered" *ngIf="section.steps?.length">
                        <li *ngFor="let step of section.steps">{{ step }}</li>
                    </ol>

                    <div class="seo-page__section-actions" *ngIf="section.actions?.length">
                        <ng-container *ngFor="let action of section.actions">
                            <a *ngIf="linkIsExternal(action)"
                               class="seo-page__button seo-page__button--section"
                               [href]="externalActionUrl(action, 'section_' + section.id)"
                               (click)="trackExternalAction(action, 'section_' + section.id)"
                               [attr.rel]="action.rel || 'noopener'"
                               target="_blank">
                                {{ action.label }}
                            </a>
                            <a *ngIf="!linkIsExternal(action)"
                               class="seo-page__button seo-page__button--section"
                               [routerLink]="internalActionPath(action)"
                               [fragment]="internalActionFragment(action)">
                                {{ action.label }}
                            </a>
                        </ng-container>
                    </div>
                </div>
                <figure class="seo-page__figure" data-aos="zoom-out"
                        [attr.data-aos-delay]="getAosDelay(sectionIndex + 1, 80, 240)">
                    <img [src]="section.image.src" [alt]="section.image.alt" loading="lazy" decoding="async">
                    <figcaption *ngIf="section.image.caption">{{ section.image.caption }}</figcaption>
                </figure>
            </div>

            <ng-template #textOnlySection>
                <p *ngFor="let paragraph of section.paragraphs">{{ paragraph }}</p>

                <ul class="seo-page__plain-list" *ngIf="section.bullets?.length">
                    <li *ngFor="let bullet of section.bullets">{{ bullet }}</li>
                </ul>

                <ol class="seo-page__plain-list seo-page__plain-list--ordered" *ngIf="section.steps?.length">
                    <li *ngFor="let step of section.steps">{{ step }}</li>
                </ol>

                <div class="seo-page__section-actions" *ngIf="section.actions?.length">
                    <ng-container *ngFor="let action of section.actions">
                        <a *ngIf="linkIsExternal(action)"
                           class="seo-page__button seo-page__button--section"
                           [href]="externalActionUrl(action, 'section_' + section.id)"
                           (click)="trackExternalAction(action, 'section_' + section.id)"
                           [attr.rel]="action.rel || 'noopener'"
                           target="_blank">
                            {{ action.label }}
                        </a>
                        <a *ngIf="!linkIsExternal(action)"
                           class="seo-page__button seo-page__button--section"
                           [routerLink]="internalActionPath(action)"
                           [fragment]="internalActionFragment(action)">
                            {{ action.label }}
                        </a>
                    </ng-container>
                </div>
            </ng-template>

            <div class="seo-page__cards" *ngIf="section.cards?.length">
                <article class="seo-page__card" *ngFor="let card of section.cards; let cardIndex = index"
                         data-aos="fade-up" [attr.data-aos-delay]="getAosDelay(cardIndex, 80, 240)">
                    <h3>{{ card.title }}</h3>
                    <p>{{ card.text }}</p>
                    <a *ngIf="card.action && linkIsExternal(card.action)"
                       class="seo-page__card-link"
                       [href]="externalActionUrl(card.action, 'card_' + section.id)"
                       (click)="trackExternalAction(card.action, 'card_' + section.id)"
                       [attr.rel]="card.action.rel || 'noopener'"
                       target="_blank">
                        {{ card.action.label }}
                    </a>
                    <a *ngIf="card.action && !linkIsExternal(card.action)"
                       class="seo-page__card-link"
                       [routerLink]="internalActionPath(card.action)"
                       [fragment]="internalActionFragment(card.action)">
                        {{ card.action.label }}
                    </a>
                </article>
            </div>

            <div class="seo-page__note" *ngIf="section.note">{{ section.note }}</div>
        </section>

        <app-faq-section
            [items]="page.faq"
            [animated]="true"
            description="Ответы на ключевые вопросы о сценариях работы в MotorDesk, возможностях личного кабинета и демо-режиме.">
        </app-faq-section>
    </div>

    <section class="seo-page__cta" data-aos="fade-up">
        <div class="container">
            <div class="seo-page__cta-panel">
                <div>
                    <div class="seo-page__eyebrow">Следующий шаг</div>
                    <h2>{{ page.cta.title }}</h2>
                    <p>{{ page.cta.text }}</p>
                </div>
                <div class="seo-page__actions">
                    <a *ngIf="page.cta.primaryAction && linkIsExternal(page.cta.primaryAction)"
                       class="seo-page__button seo-page__button--light"
                       [href]="externalActionUrl(page.cta.primaryAction, 'footer_primary')"
                       (click)="trackExternalAction(page.cta.primaryAction, 'footer_primary')"
                       [attr.rel]="page.cta.primaryAction.rel || 'noopener'"
                       target="_blank">
                        {{ page.cta.primaryAction.label }}
                    </a>
                    <a *ngIf="page.cta.primaryAction && !linkIsExternal(page.cta.primaryAction)"
                       class="seo-page__button seo-page__button--light"
                       [routerLink]="internalActionPath(page.cta.primaryAction)"
                       [fragment]="internalActionFragment(page.cta.primaryAction)">
                        {{ page.cta.primaryAction.label }}
                    </a>

                    <a *ngIf="page.cta.secondaryAction && linkIsExternal(page.cta.secondaryAction)"
                       class="seo-page__button seo-page__button--ghost-light"
                       [href]="externalActionUrl(page.cta.secondaryAction, 'footer_secondary')"
                       (click)="trackExternalAction(page.cta.secondaryAction, 'footer_secondary')"
                       [attr.rel]="page.cta.secondaryAction.rel || 'noopener'"
                       target="_blank">
                        {{ page.cta.secondaryAction.label }}
                    </a>
                    <a *ngIf="page.cta.secondaryAction && !linkIsExternal(page.cta.secondaryAction)"
                       class="seo-page__button seo-page__button--ghost-light"
                       [routerLink]="internalActionPath(page.cta.secondaryAction)"
                       [fragment]="internalActionFragment(page.cta.secondaryAction)">
                        {{ page.cta.secondaryAction.label }}
                    </a>
                </div>
            </div>
        </div>
    </section>
</article>
